import { TdsItem } from '../enum/tds';

export const TDS_PLATFORM_LIST = [
  {
    title: '监控定位',
    key: TdsItem.Bugly,
  },
  {
    title: '智能低代码',
    key: TdsItem.Wuji,
  },
  {
    title: '跨平台框架',
    key: TdsItem.Hippy,
  },
  {
    title: '全场景发布',
    key: TdsItem.Shiply,
  },
  {
    title: '应用合规',
    key: TdsItem.Rightly,
  },
  {
    title: '更多产品',
    key: TdsItem.Home,
  },
];

export const DEFAULT_ICP = '粤B2-20090059';
export const DEFAULT_ICP_URL = 'https://beian.miit.gov.cn/#/Integrated/index';
